const $header = document.querySelector("header");
const $menuMobile = document.querySelector("#mobile-menu");

function ScrollHeaderSticky() {
	const $headerFixer = document.querySelector("#header__fixer");
	const headerHeight = $header.offsetHeight;

	$header.classList.add("position-fixed");
	$headerFixer.style.height = `${headerHeight}px`;
	$menuMobile.style.top = `${headerHeight}px`;

	function scrollHeader() {
		const $headerInfo = $header.querySelector("#header-info");
		const { scrollTop } = document.documentElement;
		const isFixed = scrollTop > headerHeight;

		$headerInfo.classList.toggle("hidden", isFixed);
	}
	window.addEventListener("scroll", scrollHeader);
	document.querySelectorAll("[data-sticky]").forEach((i) => i.style.top = `${headerHeight + 10}px`);
}

function MenuHover() {
	const $menuDesktopItems = $header.querySelectorAll("#navbar-td [data-nav-hover=\"true\"]");

	$header.addEventListener("mouseleave", () => {
		$header.querySelectorAll("#navbar-td .td-hover-menu.active")?.forEach((i) => i.classList.remove("active"));
	});

	$menuDesktopItems.forEach((item) => {
		const $hoverMenu = item.querySelector(".td-hover-menu");

		item.addEventListener("mouseover", function () {
			$header.querySelectorAll("#navbar-td .td-hover-menu.active")?.forEach((i) => i.classList.remove("active"));
			if (!$hoverMenu) return;

			const corrector = 10;
			const $menuArrow = this.querySelector(".td-hover-menu__arrow");
			const linkPosition = this.querySelector(".nav-link").getBoundingClientRect();
			const headerPositionRight = $header.getBoundingClientRect().right;
			const menuPositionRight = $hoverMenu.getBoundingClientRect().right;

			$menuArrow.style.top = `${linkPosition.bottom + 20}px`;
			$menuArrow.style.left = `${linkPosition.left + 20}px`;

			if (headerPositionRight - corrector < menuPositionRight) {
				while (headerPositionRight - corrector < $hoverMenu.getBoundingClientRect().right) {
					const pLeft = $hoverMenu.style.left.replace("px", "") || -20;
					$hoverMenu.style.left = `${pLeft - corrector}px`;
				}
			}

			$hoverMenu.classList.add("active");
		});
	});
}

function eventToggleMobMenu() {
	document.querySelector("#mobile-menu").addEventListener("show.bs.collapse", () => document.body.classList.add("overflow-hidden"));
	document.querySelector("#mobile-menu").addEventListener("hidden.bs.collapse", () => document.body.classList.remove("overflow-hidden"));
}

document.addEventListener("DOMContentLoaded", () => {
	ScrollHeaderSticky();
	MenuHover();
	eventToggleMobMenu();
}, false);
